import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-i-small', 'LetterISmall', [["path",{"d":"M12 8v8","key":"svg-0"}]]);